import React, { useState } from "react";
import AddContactsToProjectsColumns from "./columns";
import Table from "../../../../../../components/table/table";
import { Typography } from "@mui/material";
import { AddContactsToCompanyModalStyled } from "./add-contacts-to-company-modal.styles";
import { contactsCollection } from "../../../../../../services/firebase";
import useContacts from "../../../../../../hooks/useContacts";

const AddContactsToCompanyModal = ({
  onClose,
  companyID,
  companyName,
  onSuccess,
}) => {
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [isDataUpdating, setIsDataUpdating] = useState(false);
  const { contacts, isLoading, isError, error } = useContacts();

  // Filter unassigned contacts
  const unAssignedContacts = contacts?.filter(
    (contact) => !contact.companyID || contact.companyID === ""
  );

  const mappedContacts = unAssignedContacts?.map((contact) => ({
    ...contact,
    name: `${contact?.firstName} ${contact?.lastName}`,
    title: contact?.title,
    id: contact?.id,
  }));

  const handleSave = async () => {
    try {
      setIsDataUpdating(true);

      const promises = selectedContacts.map((id) => {
        return contactsCollection.doc(id).update({ companyID });
      });

      await Promise.all(promises);
      onSuccess();
    } catch (error) {
      console.error("Error updating contacts:", error);
    } finally {
      setIsDataUpdating(false);
    }
  };

  return (
    <AddContactsToCompanyModalStyled
      confirmBtnTitle="Add Contact(s)"
      closeBtnTitle="Cancel"
      isConfirming={isDataUpdating}
      disableConfirmBtn={false}
      onConfirm={handleSave}
      onClose={onClose}
    >
      <div className="body">
        <div className="heading">
          <Typography
            variant={"body2"}
          >{`ID: ${companyID} | ${companyName}`}</Typography>
          <Typography variant={"h4"}>
            Select contact(s) to add to your company
          </Typography>
        </div>
        <div className="table">
          <Table
            data={mappedContacts}
            columns={AddContactsToProjectsColumns(
              selectedContacts,
              setSelectedContacts
            )}
            noDataMessage={"No contacts available"}
            sortable
            stickyHeader={true}
          />
        </div>
      </div>
    </AddContactsToCompanyModalStyled>
  );
};

export default AddContactsToCompanyModal;
